function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import Slide from '@material-ui/core/Slide';
import { SnackbarContentWrapper, EmojiIconMessageContainer, LinearProgressContainer, IconContainer, ActionRowContainer, EmojiContainer, SnackbarMUIContainer, ActionButton } from './Snackbar.styled';
import { jsx as ___EmotionJSX } from "@emotion/core";

const snackbarContentClasses = isLightVariant => ({
  root: `snackbarContentRoot ${isLightVariant ? 'snackbarContentRootLight' : 'snackbarContentRootDark'}`,
  message: 'snackbarContentClasses'
});

export const STANDARD_BUTTONS = {
  dismiss: {
    label: 'Dismiss',
    ariaLabel: 'dismiss',
    key: 'close',
    onClick: () => undefined
  },
  retry: {
    label: 'Retry',
    ariaLabel: 'retry',
    key: 'retry',
    onClick: () => undefined
  }
}; // isLightVariant is typically used only for Snackbars that relate to a progress bar, such as uploading, error uploading and upload successful

const Snackbar = ({
  open,
  icon,
  progress,
  isLightVariant,
  actionButtons,
  onClose,
  emoji,
  message,
  autoHideDuration,
  children,
  className,
  'data-testid': dataTestId
}) => {
  const actionButtonsElements = (actionButtons || [_objectSpread(_objectSpread({}, STANDARD_BUTTONS.dismiss), {}, {
    onClick: onClose
  })]).map(({
    ariaLabel,
    key,
    label,
    onClick
  }) => ___EmotionJSX(ActionButton, {
    key: key,
    "aria-label": ariaLabel || key,
    onClick: onClick,
    type: "text",
    size: "small"
  }, ___EmotionJSX("span", null, label)));
  return ___EmotionJSX(SnackbarMUIContainer, {
    open: open,
    onClose: onClose,
    TransitionComponent: Slide,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    autoHideDuration: autoHideDuration,
    className: className,
    "data-testid": dataTestId
  }, ___EmotionJSX(SnackbarContentWrapper, {
    classes: snackbarContentClasses(isLightVariant),
    message: children || ___EmotionJSX("span", null, ___EmotionJSX(EmojiIconMessageContainer, null, emoji && ___EmotionJSX(EmojiContainer, null, emoji), icon && ___EmotionJSX(IconContainer, null, icon), message && ___EmotionJSX("span", null, message)), !!actionButtonsElements.length && ___EmotionJSX(ActionRowContainer, null, actionButtonsElements), progress !== null && ___EmotionJSX(LinearProgressContainer, {
      variant: "determinate",
      value: progress
    }))
  }));
};

Snackbar.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  emoji: PropTypes.string,
  icon: PropTypes.node,
  isLightVariant: PropTypes.bool,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  autoHideDuration: PropTypes.number,
  actionButtons: PropTypes.arrayOf(PropTypes.shape({
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    ariaLabel: PropTypes.string
  })),
  progress: PropTypes.number,
  children: PropTypes.element,
  className: PropTypes.string,
  'data-testid': PropTypes.string
};
Snackbar.defaultProps = {
  emoji: null,
  onClose: null,
  icon: null,
  isLightVariant: false,
  message: null,
  autoHideDuration: 5000,
  actionButtons: null,
  progress: null,
  children: null,
  className: null,
  'data-testid': null
};
export default Snackbar;
//# sourceMappingURL=Snackbar.js.map